<template>
  <md-container class="app-wrap">
    <md-header class="app-header" v-show="!hiddenLayout">
      <div class="home-logo">
        <md-image :src="anntoLogo" class="logo-img">
          <template #placeholder>
            <div class="image-slot">Loading<span class="dot">...</span></div>
          </template>
        </md-image>
        <div class="header-title" v-if="currentRoleConfig.showInHeader" :style="currentRoleConfig.textStyle"> {{ currentRoleConfig.title }}</div>
        <div class="header-title" v-else>数字化运营平台</div>
      </div>
      <top-nav></top-nav>
    </md-header>
    <md-container class="app-container">
      <md-aside class="app-aside" :class="{'hide-title': !currentRoleConfig.showInSider}" v-show="!hiddenLayout">
        <lots-side-bar-v2
          ref="lotsSideBarRef"
          :authority="authority"
          :set-local-storage="setMenu"
          :show-search-result-hover-popover="true"
          menu-draggable
          is-need-add-menu
          @menu-click="menuClick"
        >
          <template #logo="{ isCollapsed }" v-if="currentRoleConfig.showInSider">
              <div class="app-aside-top" :class="{'collapsed': isCollapsed}">
                <img v-if="currentRoleConfig.logo.length > 0" class="aside-top-img" :src="currentRoleConfig.logo"/>
                <span v-if="!isCollapsed" class="aside-top-title">{{ currentRoleConfig.title}}</span>
              </div>
          </template>
          <template #non-menu-tip>
            <div class="non-menu-tip">
              尚未添加菜单
              <p>可在右侧浮窗对应菜单图标进行点亮，固定到菜单栏</p>
            </div>
          </template>
          <template #menu-icon-slot="data">
            <component :is="resolveComponent(data.icon)" />
          </template>
        </lots-side-bar-v2>
      </md-aside>
      <md-container>
        <md-header class="app-tags" v-show="!hiddenLayout">
          <page-tags :visited-views="visitedViews" :authority="authority" :tab-width="140" />
        </md-header>
        <md-main class="app-main">
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" v-if="isRouterShow" :key="route.name" />
            </keep-alive>
          </router-view>
        </md-main>
      </md-container>
    </md-container>
    <overdue-reasons-force-control-reminder-dialog
      v-model="overdueDialogVisible"
      :task-count="overdueTaskCount"
      :downloading="overdueDownloading"
      @close-button-click="handleOverdueDialogClose"
      @go-remark="handleOverdueGoRemark"
      @download="handleOverdueDownload"
    />
    <overdue-reasons-force-control-close-tip-dialog
      v-model="overdueCloseTipVisible"
      :poll-minutes="overduePollMinutes"
      @close="closeOverdueCloseTipDialog"
    />
  </md-container>
</template>
<script lang="ts">
import { defineComponent, onMounted, provide, ref, computed, defineAsyncComponent, watch, nextTick } from 'vue';
import { lotsSideBarV2, lotsHeader, setMenuDataLocalStorage, sendMenuData } from '@annto/ui';
// import {
//   lotsSideBarV2,
//   lotsHeader,
//   setMenuDataLocalStorage,
//   sendMenuData,
// } from '../../../ui/components/packages/lots-ui/lots';
import PageTags from '@/components/PageTags/index.vue';
import TopNav from '@/components/TopNav/index.vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore, mapGetters } from 'vuex';
import anntoLogo from '@/assets/annto_logo.svg';
import { useMenuClick } from '@/hooks/useMenuClick';
import cookies from 'js-cookie';
import { getControlParam, getUserRole } from '@/api/userApi';
import { storageResource } from './login/components/utilsLogin';
import config from '@/config/user.env';
import { MdMessage } from 'mdesign3';
import { IStorageResourceParams } from '@/utils/interface';
import { logout } from '@/utils';
import { getConfig } from '@/config/role-config';
import { UserRoleHelper } from '@/utils/userRoleHelper';
import OverdueReasonsForceControlReminderDialog from '@/components/overdueReasonsForceControlReminderDialog/index.vue';
import OverdueReasonsForceControlCloseTipDialog from '@/components/overdueReasonsForceControlCloseTipDialog/index.vue';
import { useOverdueReasonsForceControlReminderPoll } from '@/hooks/useOverdueReasonsForceControlReminderPoll';

export default defineComponent({
  name: 'App',
  components: {
    PageTags,
    TopNav,
    lotsSideBarV2,
    lotsHeader,
    OverdueReasonsForceControlReminderDialog,
    OverdueReasonsForceControlCloseTipDialog,
  },
  setup() {
    const { menuClick } = useMenuClick();
    const {
      dialogVisible: overdueDialogVisible,
      closeTipVisible: overdueCloseTipVisible,
      taskCount: overdueTaskCount,
      pollMinutes: overduePollMinutes,
      downloading: overdueDownloading,
      handleDialogClose: handleOverdueDialogClose,
      closeTipDialog: closeOverdueCloseTipDialog,
      handleGoRemark: handleOverdueGoRemark,
      handleDownload: handleOverdueDownload,
    } = useOverdueReasonsForceControlReminderPoll();
    const newAuthority = ref<any>([]);
    const lotsSideBarRef = ref(null); // 确保这个引用存在
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const visitedViews = computed(() => store.getters.visitedViews);
    const authority = computed(() => store.getters.authority);
    const hiddenLayout = computed(() => route.path.includes('/skyeye-dashboard/skyeye-overview'));
    // 获取当前用户角色下的显示角色配置项
    const currentRoleConfig = computed(() => {
      // const { curRole, roleList } = store.state;
      // const roleItem = roleList.find((item: { roleCode: any }) => item.roleCode === curRole);
      return getConfig(store)
    });
 
    const setMenu = (info, frontUrl, resourceCode) => {
      if (frontUrl && info && info.length > 0 && resourceCode) {
        setMenuDataLocalStorage(store, info, frontUrl, resourceCode);
      }
    };

    sendMenuData();

    // 注入刷新页面方法
    const isRouterShow = ref(true);
    const refreshCurrentPage = (val: boolean) => (isRouterShow.value = val);
    provide('refresh', refreshCurrentPage);

    const handleSelect = () => {
      // const { appid, type, index } = store.getters.currentAppMenu;
      // toMicroApp(appid, type, index);
    };
    provide('getAppAuthorityMenuList', handleSelect);

    onMounted(() => {
      // toMicroApp(item.appid, item.type, item.index)
      setMenuDataLocalStorage(store);
    });
    // 监听是否为同一用户，不是就刷新页面重置权限
    if (document.hidden !== undefined) {
      document.addEventListener('visibilitychange', () => {
        const apmUser = cookies.get('apmUser');
        const { user } = store.state;
        if (!document.hidden && apmUser !== user['apmUser']) {
          // window.location.reload();
          getUserRoleFn(apmUser);
        }
      });
    }
    // 获取用户角色
    const getUserRoleFn = async (apmUser: string | undefined) => {
        if(apmUser === undefined) {
          return;
        }
        const params = {
          userCode: apmUser,
          positionCode: 'main',
          applicationCode: config.applicationCode,
        };
        const roles = await getUserRole(params);
        if (!roles?.data || roles?.data.length === 0) {
          UserRoleHelper.showNoRoleMessage();
          setTimeout(() => {
            logout(true);
          }, 1000);
          return;
        }
        if (roles.code === '0' && roles?.data.length > 0) {
          getControlParamFn(roles?.data);
        }
    };
    // 获取角色组
    const getControlParamFn = async (accountDatas: any) => {
      let roleList = [];
      let roleGroupData = [];
      try {
        const params = {
          applicationCode: config.applicationCode,
          code: 'EL_ROLE_GROUP',
        };
        const res = await getControlParam(params);
        const resData = res.data?.value;
        const roleGroupResult = JSON.parse(resData);
        const roleGroupList =
          roleGroupResult &&
          roleGroupResult.map((item: any) =>
            item.roleGroupValue.map((e: any) => {
              e.roleGroupCode = item.roleGroupCode;
              e.roleGroupName = item.roleGroupName;
              return e;
            }),
          );
        roleList = roleGroupList && roleGroupList.flat();
      } catch (error) {
        roleList = [];
      }
      const roleCodeArr = roleList && roleList.map((item: any) => item.roleCode);

      if (roleCodeArr && roleCodeArr.length > 0) {
        let tableData = [];
        const tableList = accountDatas;
        let innerGroup = tableList.filter((item: any) => roleCodeArr.includes(item.roleCode));
        const outerGroup = tableList.filter((item: any) => !roleCodeArr.includes(item.roleCode));
        if (innerGroup && innerGroup.length > 0) {
          innerGroup = innerGroup.map((item: any) => {
            item.roleName = roleList.find((role: any) => role.roleCode === item.roleCode)?.roleGroupName || item.roleName;
            item.roleGroupCode = roleList.find((role: any) => role.roleCode === item.roleCode)?.roleGroupCode;
            return item;
          });
          const groupedDealData = innerGroup.reduce((acc: any, current: any) => {
            const groupCode = current.roleGroupCode;
            if (!acc[groupCode]) {
              acc[groupCode] = [];
            }
            acc[groupCode].push(current);
            return acc;
          }, {});
          const groupedDealDataArr = Object.keys(groupedDealData).map((key) => groupedDealData[key]);
          let uniquesGroup: any[] = [];
          groupedDealDataArr.map((group) => {
            const tableListArr = group.map((item: any) => item.userCode);
            let uniques = tableListArr.filter((value: any, index: any, self: any) => self.indexOf(value) === index);
            if (uniques && uniques.length > 0) {
              uniques = uniques.map((item: any) => {
                const roleArr = group.filter((role: any) => role.userCode === item);
                const roleCodes = roleArr.map((role: any) => role.roleCode);
                const roleObj = roleArr && roleArr[0];
                roleObj.roleCode = roleCodes.join(',');
                return roleObj;
              });
              uniquesGroup.push(...uniques);
            }
          });
          tableData = [...uniquesGroup, ...outerGroup];
        } else {
          tableData = [...tableList];
        }
        roleGroupData = tableData;
      } else {
        roleGroupData = accountDatas;
      }
      // 更新角色信息
      const params: IStorageResourceParams = {
        roleCode: roleGroupData && roleGroupData[0].roleCode,
        roleList: roleGroupData,
      };

      if (roleGroupData && roleGroupData.length === 1) {
        await storageResource(params);
        window.location.reload();// 刷新页面
      } else if (roleGroupData && roleGroupData.length > 1) {
        MdMessage.error('您当前账号存在多个角色，请重新登录');
        setTimeout(() => {
          logout(true);
        }, 1000);
        // window.location.replace('/');// 切换到首页
      }
    };

    // 默认图标仅走动态 import，避免与下方 resolveComponent 的按需加载重复引用，消除 Vite 构建告警
    const IconElDefaultAsync = defineAsyncComponent(() => import('@/assets/menus/IconElDefault.vue'));

    const resolveComponent = (componentName: string) => {
      return defineAsyncComponent({
        loader: () => import(`@/assets/menus/${componentName}.vue`),
        delay: 200, // 可选：延迟加载时间
        timeout: 5000, // 可选：超时时间
        errorComponent: IconElDefaultAsync, // 图标加载失败时回退为默认图标（动态引入，勿改静态 import）
        loadingComponent: null, // 可选：加载中的组件
        suspense: false, // 可选：是否使用 Suspense 组件
      });
    };
    // 添加手动控制侧边栏展开/收缩的方法
    const toggleSidebar = () => {
      if (lotsSideBarRef.value) {
        // 调用组件内部的 handleFixedChange 方法来切换展开/收缩状态
        (lotsSideBarRef.value as any).handleFixedChange();
      }
    };
    // 如果只想收缩侧边栏（不切换状态）
    const collapseSidebar = () => {
      if (lotsSideBarRef.value && (lotsSideBarRef.value as any).isUnfold) {
        // 如果已经是收缩状态，则无需操作；如果不是收缩状态，则调用切换方法
        (lotsSideBarRef.value as any).handleFixedChange();
      }
    };
    
    // 如果只想展开侧边栏（不切换状态）
    const expandSidebar = () => {
      if (lotsSideBarRef.value && !(lotsSideBarRef.value as any).isUnfold) {
        // 如果已经是展开状态，则无需操作；如果是收缩状态，则调用切换方法
        (lotsSideBarRef.value as any).handleFixedChange();
      }
    };
    // 监听路由变化
    watch(
      () => route.path,
        (newPath) => {
          nextTick(() => {
            // 利用 nextTick 确保 DOM 已经更新，组件引用已经可用。
            if (newPath.includes('/ros/monitor-board')) {
              collapseSidebar(); // 隐藏侧边栏
            }
          });        
      },
      {
        immediate: true // 立即执行一次，确保初始状态下也应用正确的侧边栏状态
      }
    );

    return {
      anntoLogo,
      route,
      isRouterShow,
      newAuthority,
      visitedViews,
      hiddenLayout,
      authority,
      setMenu,
      resolveComponent,
      menuClick,
      currentRoleConfig,
      lotsSideBarRef,
      toggleSidebar,    // 新增：切换侧边栏展开/收缩
      collapseSidebar,  // 新增：收缩侧边栏
      expandSidebar,    // 新增：展开侧边栏
      overdueDialogVisible,
      overdueCloseTipVisible,
      overdueTaskCount,
      overduePollMinutes,
      overdueDownloading,
      handleOverdueDialogClose,
      closeOverdueCloseTipDialog,
      handleOverdueGoRemark,
      handleOverdueDownload,
    };
  },
  computed: {
    ...mapGetters(['applicationCode', 'authority']),
  },
});
</script>

<style lang="less">
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1);
  background-clip: padding-box;
  min-height: 28px;
  border-radius: 2em;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.4);
}
.app-wrap.md-container {
  .app-header {
    display: flex;
    align-items: center;
    box-shadow: none;
    .home-logo {
      display: flex;
      align-items: center;
      flex: 1;
      .logo-img {
        // height: 16px;
        margin-right: 16px;
      }
      .header-title {
        position: relative;
        font-size: 18px;
        color: #1d2129;
        line-height: 25px;
        // &:before {
        //   content: '';
        //   position: absolute;
        //   top: 58%;
        //   left: -20px;
        //   width: 1px;
        //   height: 14px;
        //   margin-top: -8px;
        //   background-color: #f2f3f5;
        // }
      }
    }
  }
}

.app-container {
  overflow: hidden;
}
/* 当 .app-aside 含有 .hide-title 类时，.sidebar-title 将被隐藏 */
.app-aside.hide-title .sidebar-title {
  display: none;
}
// 侧边栏顶部
.app-aside-top {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px; // 默认显示时的间隙

  &.collapsed {
    gap: 0; // 折叠时移除间隙
    justify-content: center; // 仅居中图片
  }
  .aside-top-img {
    width: 16px;
    height: 16px;
  }
  .aside-top-title {
    font-size: 16px;
    line-height: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #2881FF;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 44px); // 最大宽度限制, 减去图片宽度和间隙, 给图片左侧和文本右侧留出空间
    text-align: center;
    display: inline-block;
  }
}

.md-container {
  .md-main {
    overflow: hidden;
  }
  .md-main.annt-container {
    --md-main-padding: 0 10px 10px 10px;
  }
  .non-menu-tip {
    padding: 8px 35px 8px 46px;
    color: #86909c;
    line-height: 20px;
    font-size: 12px;
    p {
      color: #1d2129;
    }
  }
}
.app-tags {
  background-color: #F4F5F8;
}
</style>
